import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function checkVerifyCode(pathname, queryParams = "", body) {
  return await instance({ baseURL: baseURL }).post(
    pathname + queryParams,
    body
  );
}

export async function sendVerifyCode(pathname, queryParams = "", body) {
  return await instance({ baseURL: baseURL }).post(
    pathname + queryParams,
    body
  );
}
